import React from "react";
import { Link } from "react-router-dom";
import { ArchiveBoxIcon, ShieldCheckIcon } from "@heroicons/react/24/outline";

const HomePage = () => {
  return (
    <div className="mx-auto max-w-6xl py-12">
      <section className="rounded-2xl border border-sky-500/10 bg-white/85 p-8 shadow-xl shadow-slate-950/5 backdrop-blur dark:bg-slate-950/70">
        <p className="text-sm font-bold uppercase text-sky-500 dark:text-sky-400">Base applicative</p>
        <h1 className="mt-3 max-w-3xl text-3xl font-black text-slate-950 dark:text-white sm:text-4xl">
          Stockage de fichiers avec comptes, administration et logs prêts à étendre.
        </h1>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link
            to="/stockage"
            className="inline-flex items-center gap-2 rounded-xl bg-sky-500 px-5 py-3 text-sm font-bold text-white transition hover:bg-sky-600"
          >
            <ArchiveBoxIcon className="size-5" />
            Ouvrir le stockage
          </Link>
          <Link
            to="/administration"
            className="inline-flex items-center gap-2 rounded-xl border border-sky-300/40 px-5 py-3 text-sm font-bold text-slate-700 transition hover:bg-sky-500/10 dark:text-slate-200"
          >
            <ShieldCheckIcon className="size-5" />
            Administration
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
